import { createFileRoute } from "@tanstack/react-router";
import { EmpresaPage } from "@/paginas/pg_empresa/empresa-main";

export const Route = createFileRoute("/_authenticated/empresa")({
  head: () => ({
    meta: [
      { title: "Empresa — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Gestão da empresa: horários de funcionamento, filiais cadastradas e funcionários com suas equipes.",
      },
      { property: "og:title", content: "Empresa — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Gestão da empresa: horários de funcionamento, filiais cadastradas e funcionários com suas equipes.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: EmpresaPage,
});
